import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { caps12 } from '../../styles/typography';
import { useLotTimer } from '../../utils/use-lot-timer';
import { Skeleton } from '../skeleton/skeleton';

export const Timer = styled.div<{ soon?: boolean }>`
  ${caps12};
  color: ${(props) => color(props.soon ? 'red60' : 'navy100')(props)};
  margin-bottom: ${gutter(2)};
`;

export function timerText(ms: number) {
  const diff = Math.floor(ms / 1000) + 1;
  if (diff <= 0) {
    return null;
  }

  const seconds = diff % 60;
  const minutes = Math.floor(diff / 60) % 60;
  const hours = Math.floor(diff / 60 / 60) % 24;
  const days = Math.floor(diff / 60 / 60 / 24);

  const units = ['d', 'h', 'm', 's'];
  const output = [days, hours, minutes, seconds]
    .map((v, i) => (v === 0 ? null : `${(v || 0).toString()}${units[i]}`))
    .filter((n) => !!n)
    .join(' ');

  return output;
}

const SOON = 10 * 60 * 1000;
const DAY = 24 * 60 * 60 * 1000;

export const LotTimer = ({
  startsAt,
  endsAt,
  isLoading,
  ...rest
}: {
  startsAt?: string;
  endsAt?: string;
  isLoading?: boolean;
}) => {
  const { isStarted, isEnded, startsIn, endsIn } = useLotTimer({
    startsAt,
    endsAt,
  });

  let content;
  let soon = false;
  if (isLoading) {
    content = <Skeleton width={230} height={21} visible />;
  } else {
    if (!isStarted && startsAt) {
      if (startsIn > DAY) {
        content = (
          <>
            Lot opens{' '}
            {new Intl.DateTimeFormat('en-US', {
              day: 'numeric',
              month: 'short',
              hour: 'numeric',
              minute: 'numeric',
              timeZoneName: 'short',
            }).format(new Date(startsAt || ''))}
          </>
        );
      } else {
        content = <>Lot opens in {timerText(startsIn)}</>;
      }
    } else if (!isEnded && endsAt) {
      if (endsIn < SOON) {
        soon = true;
      }
      if (endsIn > DAY) {
        content = (
          <>
            Lot closes{' '}
            {new Intl.DateTimeFormat('en-US', {
              day: 'numeric',
              month: 'short',
              hour: 'numeric',
              minute: 'numeric',
              timeZoneName: 'short',
            }).format(new Date(endsAt || ''))}
          </>
        );
      } else {
        content = <>Lot closes in {timerText(endsIn)}</>;
      }
    } else if (!endsAt || !startsAt) {
      content = <></>;
    } else {
      soon = true;
      content = <>Lot closed</>;
    }
  }

  return (
    <Timer soon={soon} {...rest}>
      {content}
    </Timer>
  );
};
